import React, { useState, useCallback, useEffect } from "react";
import { Form, Modal, Select, Message } from "semantic-ui-react";
import { useForm } from "react-hook-form";
import { useAuth } from "../../../AuthenticationStore";
import { proccessError } from "../../../components/utils/utils";

const optionsNumeric = [];

for (let index = 0; index < 24; index++) {
  const valueString = (index + 1).toString();
  optionsNumeric.push({
    key: valueString,
    text: index === 0 ? "Una vez al Día" : `Cada ${index} hora(s)`,
    value: `0 0 0/${index} ? * * *`
  });
}

export const CompanyModal = ({ handleClose, show, data }) => {
  const [numberCron, setNumberCron] = useState("");
  const { companyService } = useAuth();
  const [errorsApi, setErrorsApi] = useState([]);

  const save = () => {
    handleClose(false);
  };

  const { handleSubmit, register, errors, setValue } = useForm();

  useEffect(() => {
    if (!data) return;

    for (const key in data) {
      // eslint-disable-next-line no-prototype-builtins
      if (data.hasOwnProperty(key)) {
        const value = data[key];
        if (key === 'configuration' && value) {
          setNumberCron(value['cron'])
        } else {
          setValue(key, value);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const onSubmit = async values => {
    values.state = "Activo";
    values.configuration = JSON.stringify({ cron: numberCron });

    try {
      // use create company
      let response;
      if (!data) {
        response = await companyService.createCompany(values);
      } else {
        let temporal = Object.assign(data, {});
        for (const key in temporal) {
          // eslint-disable-next-line no-prototype-builtins
          if (temporal.hasOwnProperty(key) && values[key]) {
            temporal[key] = values[key];
          }
        }
        // use update company
        response = await companyService.updateCompany(temporal);
      }

      const arrayErrors = proccessError(response);
      setErrorsApi(arrayErrors);
      if (response.result) save();
    } catch (error) {
      if (error.response) {
        // eslint-disable-next-line no-console
        const arrayErrors = proccessError(error.response.data, true);
        setErrorsApi(arrayErrors);
      } else {
        setErrorsApi([error.message]);
      }
    }
  };

  const changeNumberCron = useCallback(
    (_, newValue) => setNumberCron(newValue.value),
    [setNumberCron]
  );

  return (
    <Modal open={show} onClose={handleClose} closeIcon>
      <Modal.Header>{data ? "Editar" : "Agregar"} compañía</Modal.Header>
      <Modal.Content>
        {errorsApi.length > 0 ? (
          <Message error>
            <Message.Header>Errores</Message.Header>
            <Message.List items={errorsApi} />
          </Message>
        ) : null}
        <Form onSubmit={handleSubmit(onSubmit)}>
          <h2>Información General</h2>

          <Form.Group widths="equal">
            <Form.Input
              error={!!errors.companyName}
              fluid
              label="Nombre Compañía"
              placeholder="Nombre Compañía"
            >
              <input
                name="companyName"
                ref={register({
                  required: "Required"
                })}
              />
            </Form.Input>
            <Form.Input
              fluid
              error={!!errors.identification}
              label="Identificacion"
              placeholder="Identificacion"
            >
              <input
                name="identification"
                ref={register({
                  required: "Required"
                })}
              />
            </Form.Input>
          </Form.Group>

          <Form.Input
            fluid
            error={!!errors.activeUsers}
            label="Usuarios activos"
            placeholder="Usuarios activos"
          >
            <input
              type="number"
              name="activeUsers"
              ref={register({
                pattern: {
                  message: "numero no valido",
                  value: /^[+]?\d+?$/
                },
                required: "Required"
              })}
            />
          </Form.Input>

          <Form.Group widths="equal">
            <Form.Input
              fluid
              error={!!errors.monthlyLoan}
              label="Creditos tramitados mensualmente"
              placeholder="Creditos tramitados mensualmente"
            >
              <input
                type="number"
                name="monthlyLoan"
                ref={register({
                  pattern: {
                    message: "numero no valido",
                    value: /^[+]?\d+?$/
                  },
                  required: "Required"
                })}
              />
            </Form.Input>

            <Form.Input
              fluid
              error={!!errors.concurrentCampaigns}
              label="Campañas concurrentes"
              placeholder="Campañas concurrentes"
            >
              <input
                type="number"
                name="concurrentCampaigns"
                ref={register({
                  pattern: {
                    message: "numero no valido",
                    value: /^[+]?\d+?$/
                  },
                  required: "Required"
                })}
              />
            </Form.Input>
          </Form.Group>

          <Form.Group widths="equal">
            <Form.Field
              control={Select}
              label="Sincronizar"
              options={optionsNumeric}
              value={numberCron}
              onChange={changeNumberCron}
            />
          </Form.Group>

          <h2>Información de Contacto</h2>

          <Form.Group widths="equal">
            <Form.Input
              error={!!errors.contactName}
              fluid
              label="Nombre"
              placeholder="Nombre"
            >
              <input
                name="contactName"
                ref={register({
                  required: "Required"
                })}
              />
            </Form.Input>
          </Form.Group>

          <Form.Group widths="equal">
            <Form.Input
              error={!!errors.contactPhone}
              fluid
              label="Teléfono"
              placeholder="Teléfono"
            >
              <input
                name="contactPhone"
                ref={register({
                  required: "Required"
                })}
              />
            </Form.Input>

            <Form.Input
              error={!!errors.email}
              fluid
              label="Correo electrónico"
              placeholder="Correo electrónico"
            >
              <input
                name="email"
                ref={register({
                  pattern: {
                    message: "numero no valido",
                    value: /^([a-zA-Z0-9_\-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/
                  },
                  required: "Required"
                })}
              />
            </Form.Input>
          </Form.Group>

          <button className="btn btn-primary btn-icon-text" type="submit">
            <i className="mdi mdi-content-save"></i>
            {data ? "Editar" : "Agregar"}
          </button>
        </Form>
      </Modal.Content>
    </Modal>
  );
};
